/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 데스크탑의 사이버주택전시관 페이지 컴포넌트입니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

import './style.scss';
import { exhbtListContent } from 'data/exhbt';
import { useState } from 'react';
import MoviePopup from 'common-modules/general/Common/Components/Popup/desktop/MoviePopup';

/**
 * 사이버 주택전시관 컴포넌트
 */
const Exhbt = () => {
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [selectedVideoUrl, setSelectedVideoUrl] = useState('');

  /**
   * 클릭 시 이동할 URL
   * @param path URL 정보
   * @param type 타입
   */
  const handleClickMovePage = (path: string, type: string) => {
    // 팝업 또는 페이지를 이동시키는 함수
    if (type === 'vr') {
      window.open(path, '_blank');
    } else {
      setSelectedVideoUrl(path);
      setIsOpenVideo(true);
    }
  };

  return (
    <div className="contents-exhbt">
      <div className="content">
        <section className="section-01" id="section-01">
          <div className="container mt-120">
            <div className="section-01-container t-center">
              <i className="ico-double-dot"></i>
              <h2 className="title">살수록 커지는 차이와 가치</h2>
              <p className="sub-title">간결하게 핵심만 담은 분양 정보를 언제 어디서나 편리하게 온라인에서 만나보세요</p>
            </div>
            <div className="section-01-content mt-120">
              <div className="section-tit">관람하기</div>
              <div className="section-01-list mt-40">
                {exhbtListContent &&
                  exhbtListContent.map((item, index) => (
                    <a onClick={e => handleClickMovePage(item.desktop, item.type)} key={index} className="section-01-item">
                      <div className="section-01-item-img">
                        <img src={item.img} alt="" />
                        <i className="ico-play"></i>
                      </div>
                      <div className="section-01-item-area">
                        <p className="section-01-item-tit">{item.tit}</p>
                        <p className="section-01-item-subtit">{item.subtit}</p>
                      </div>
                    </a>
                  ))}
              </div>
            </div>
          </div>
        </section>
      </div>
      <MoviePopup url={selectedVideoUrl} open={isOpenVideo} setOpen={setIsOpenVideo} />
    </div>
  );
};

export default Exhbt;
